import { RootState } from '../store';

export const selectIsFromHandOff = (state: RootState): any => state.isFromHandOff;
